import React from 'react';
import Badge from 'react-bootstrap/Badge';


export default function QualifierBadgeGroup({ qualifiers, checkedQualifiers, disqualifier = false }) {
  return (
    <span>
      {qualifiers.map((q, i) => {
        let checked = checkedQualifiers.includes(q)

        return (
          <Badge
            className="text-align-center"
            bg={checked ? (disqualifier === false ? "primary" : "danger") : "light"}
            text={checked ? "light" : "dark"}>
            {q}
          </Badge>
        );
      })}
    </span>
  );
};